// baseurl for
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL_USER_INFO = process.env.REACT_APP_API_BASE_URL_USER_INFO;


export const endpoint = {
  //Ad Campaign handler
  CAMPAIGN_HANDLER: `${BASE_URL}/companies/youtube/campaign_handler`,
  BUDGET_CALCULATOR:`${BASE_URL}/companies/youtube/budget_calculator`,
  AD_PLACEMENT_DETAILS: `${BASE_URL}/companies/youtube/upload_placement_content`,
  APPLY_COUPON: `${BASE_URL}/companies/youtube/apply_coupon`,

  USER_PROFILE: `${BASE_URL}/companies/youtube/company_profile`,

  PAYMENT_INITIATE: `${BASE_URL}/payments/youtube/initiate`,
  PAYMENT_STATUS: `${BASE_URL}/payments/youtube/status`,

  // Channel Management - Using direct URL for onboarding endpoints
  CHANNELS: `https://7j5s62ipx8.execute-api.ap-northeast-1.amazonaws.com/dev/onboarding/youtube/list-channels`,
  INSTAGRAM_AUTH_URL: `https://7j5s62ipx8.execute-api.ap-northeast-1.amazonaws.com/dev/onboarding/instagram/get_auth_url`,
  CHANNEL_DELETE: `https://7j5s62ipx8.execute-api.ap-northeast-1.amazonaws.com/dev/onboarding/youtube/delink-channel`,
  INSTAGRAM_DELINK: `https://7j5s62ipx8.execute-api.ap-northeast-1.amazonaws.com/dev/onboarding/instagram/delink_account`,

  audience: {
    totalAudience: `${BASE_URL_USER_INFO}/audience/youtube/total_audience`,
    newSubscribers: `${BASE_URL_USER_INFO}/audience/youtube/total_subscribers`,
    netSubscribers: `${BASE_URL_USER_INFO}/audience/youtube/net_subscribers`,
    subscriberRate: `${BASE_URL_USER_INFO}/audience/youtube/subscriber_rate`,
    audienceRetention: `${BASE_URL_USER_INFO}/audience/youtube/retention`,
    ageDistribution: `${BASE_URL_USER_INFO}/audience/youtube/age_distribution`,
    genderDistribution: `${BASE_URL_USER_INFO}/audience/youtube/gender_distribution`,
    topCountries: `${BASE_URL_USER_INFO}/audience/youtube/top_countries`,
    deviceDistribution: `${BASE_URL_USER_INFO}/audience/youtube/device_distribution`,
    interestCategories: `${BASE_URL_USER_INFO}/audience/youtube/interest_categories`,
    trafficSources: `${BASE_URL_USER_INFO}/audience/youtube/traffic_sources`,
    sharesDistribution: `${BASE_URL_USER_INFO}/audience/youtube/sharing_platforms`,
    premiumViews: `${BASE_URL_USER_INFO}/audience/youtube/premium_views`,
    cardPerformance: `${BASE_URL_USER_INFO}/audience/youtube/card_performance`,
    brandVideos: `${BASE_URL}/audience/youtube/get_brand_videos`, // New GET endpoint for brand videos
  }
};
